import { Skeleton } from "@/components/ui/skeleton";

const PageSkeleton = () => (
  <div className="min-h-screen bg-background">
    <div className="pt-20 pb-12 px-4 max-w-3xl mx-auto space-y-6">
      <Skeleton className="h-4 w-32 rounded-none" />
      <Skeleton className="h-8 w-3/4 rounded-none" />
      <Skeleton className="h-4 w-full rounded-none" />
      <Skeleton className="h-4 w-5/6 rounded-none" />
      <div className="space-y-4 pt-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="border-l border-border pl-4 space-y-2">
            <Skeleton className="h-4 w-full rounded-none" />
            <Skeleton className="h-4 w-2/3 rounded-none" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default PageSkeleton;
